<div class="modal fade" #shareModal id="shareModal" tabindex="-1" role="dialog" aria-labelledby="shareModal" aria-hidden="true"  data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header py-3 px-4">
          <h5 class="modal-title fw-700">Share</h5>
          <button type="button" class="close modal-close-button font-32 mt-2" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-confirm mt-2">
          <div class="text-center mb-3">
            <share-buttons [theme]="'circles-dark'" [include]="[
                'facebook',
                'twitter',
                'linkedin',
                'pinterest',
                'reddit',
                'mix',
                'vk',
                'tumblr',
                'telegram',
                'whatsapp',
                'sms',
                'email'
              ]" [url]="currentUrl" [showText]="true"></share-buttons>
          </div>
          <div class="input-group col-12 copy-input-group px-0">
            <input type="text" class="form-control" [value]="currentUrl" #copyLink readonly>
            <div class="input-group-prepend">
              <div class="input-group-text">
                <button value="click to copy" class="btn btn-black" (click)="copyToClipboard(copyLink)">Copy</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
  
